export const GET_THE_CURRENT_SYMBOL = 'GET_THE_CURRENT_SYMBOL'

export const getSymbol = (symbol) => {
    return (dispatch) => {
        dispatch({
            type: GET_THE_CURRENT_SYMBOL,
            data: symbol
        })
    }
}